<template>
  <main class="projects-view">
    <section class="user-info"><UserInfo /></section>
    <section class="welcome">
      <h4 class="-h4">Welcome,</h4>
      <p class="-ntr">Select one of your {{ welcomeMsg }}</p>
    </section>

    <section class="new-project"><NewProject /></section>

    <section
      class="selected-project"
      :style="[
        selectedProject.imagePath
          ? `background-image: url('${selectedProject.imagePath}')`
          : `background-image: var(--project-thumbnail);`,
      ]"
    >
      <SelectedProject :selectedProject="selectedProject" />
    </section>

    <section class="project-controls">
      <div
        class="btn-secondary-l"
        style="width: 100%"
        v-if="selectedProject"
        @click="handleClick(selectedProject.id)"
      >
        <p class="-ntb">Enter Project</p>
      </div>
    </section>

    <section class="projects-list">
      <ProjectsListContainer
        :projects="projects"
        :selectedProject="selectedProject"
        @selectProject="selectProject"
      />
    </section>

    <section class="projects-summary">
      <ProjectsSummary />
    </section>

    <section class="delete-project">
      <DeleteProject />
    </section>
  </main>
</template>

<script>
import UserInfo from "../components/projects/UserInfo.vue";
import ProjectsListContainer from "../components/projects/ProjectsListContainer.vue";
import NewProject from "../components/projects/NewProject.vue";
import SelectedProject from "../components/projects/SelectedProject.vue";
import ProjectsSummary from "../components/projects/ProjectsSummary.vue";
import DeleteProject from "../components/projects/DeleteProject.vue";
export default {
  components: {
    UserInfo,
    ProjectsListContainer,
    NewProject,
    SelectedProject,
    ProjectsSummary,
    DeleteProject,
  },
  data() {
    return {
      welcomeMsg: "projects",
      selectedProject: null,
      projects: [
        {
          id: 1,
          project_name: "Northern Office Complex",
          units_size: 3,
          project_admin: "Francisco Reis",
          group: "BIMMS",
          ref: "NOC.117",
          imagePath:
            "https://media.discordapp.net/attachments/928228506939297852/1029694481852801054/kaleb-tapp-1deQbU6DhBg-unsplash.jpg?width=864&height=671",
        },
        {
          id: 2,
          project_name: "Douro Crossing Metro Bridge",
          units_size: 2,
          project_admin: "Porto Metro",
          group: "Porto Metro",
          ref: "DCMB.01",
          imagePath:
            "https://www.metrodoporto.pt/thumbs/metrodoporto/uploads/news/image/401/imagem1_1_980_2500.png",
        },
        {
          id: 3,
          project_name: "Green Life Hotel",
          units_size: 1,
          project_admin: "João Aleixo",
          group: "RS Prime",
          ref: "GLH.419",
          imagePath:
            "https://media-cdn.tripadvisor.com/media/photo-s/16/f1/3b/9d/getlstd-property-photo.jpg",
        },
        {
          id: 4,
          project_name: "Highway NB34.5",
          units_size: 1,
          project_admin: "João Ribeiro",
          group: "",
          ref: "",
          imagePath:
            "https://images.unsplash.com/photo-1520594923568-1b5d82587f86?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",
        },
      ],
    };
  },
  created() {
    this.selectedProject = JSON.parse(JSON.stringify(this.projects[0]));
  },
  methods: {
    selectProject(project) {
      this.selectedProject = JSON.parse(JSON.stringify(project));
      console.log(project);
    },
    async handleClick(id) {
      await this.$store.dispatch("project", this.projects[0]);
      console.log(this.$store.state.project);
      this.$router.push({ name: "Units", params: { id } });
    },
  },
};
</script>

<style scoped>
.projects-view {
  display: grid;
  height: 100%;
  width: 100%;
  gap: 16px;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(12, 1fr);
  padding-inline: 4px;
}
.user-info {
  grid-column: 1 / span 1;
  grid-row: 1 / span 5;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
  align-self: start;
  padding-top: 4px;
}
.searchbar-container {
  grid-column: 1 / span 1;
  grid-row: span 1;
  align-self: flex-end;
  justify-self: left;
  width: 240px;
  height: 40px;
}
.new-project {
  grid-column: 1 / span 1;
  grid-row: span 1;
}
.projects-summary {
  grid-column: 1 / span 1;
  grid-row: span 2;
}
.delete-project {
  grid-column: 1 / span 1;
  grid-row: 11 / span 1;
}
.welcome {
  grid-column: 2 / span 5;
  grid-row: 1 / span 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding-inline: 1rem;
}
.welcome p {
  padding-block: 1rem;
}
.selected-project {
  position: relative;
  /* background-image: var(--project-thumbnail); */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
  width: 90%;
  justify-self: center;
  grid-column: 2 / span 2;
  grid-row: 3 / span 4;
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  box-shadow: rgba(0, 0, 0, 0.5) 0px 1px 4px 0px;
}
.project-controls {
  width: 90%;
  justify-self: center;
  grid-row: 7 / span 1;
  grid-column: 2 / span 2;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
}
.projects-list {
  grid-column: 4 / span 3;
  grid-row: 3 / span 9;
}

.logo {
  grid-column: 2 / span 2;
  grid-row: 9 / span 3;
  background-image: url("../assets/temp/temp-logo.svg");
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: contain;
  opacity: 0.25;
  transform: scale(0.85);
}

@media screen and (max-width: 1024px) {
  .projects-view {
    display: flex;
    flex-direction: column;
    padding: 32px;
    overflow-x: hidden;
    gap: 32px;
  }
  .user-info {
    flex-direction: row;
    grid-column: span 6;
    order: 2;
    justify-content: space-evenly;
    gap: 16px;
  }
  .welcome {
    order: 1;
  }
  .searchbar-container {
    order: 6;
    align-self: center;
  }
  .projects-summary {
    order: 5;
    align-self: center;
  }
  .projects-list {
    order: 7;
    align-self: center;
  }
  .new-project {
    order: 8;
    align-self: center;
  }
  .selected-project {
    order: 3;
    align-self: center;
  }
  .project-controls {
    order: 4;
    align-self: center;
  }
  .delete-project {
    order: 9;
    align-self: center;
  }
}
</style>